<template>
    <div v-show="toggleLightbox" class="lightbox">
        <div class="py3">
        <div class="lightbox-box" :class="customClass">
            <button v-if="special_lightbox == undefined" class="lightbox-close-btn" @click="toggleLightbox = false">
                <svg style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(45deg);" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 1V23" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M23 12H1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <button v-if="special_lightbox == 'update_creatorProfile_lightbox'" class="lightbox-close-btn" @click="closeUpdateCreatorProfile()">
                <svg style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(45deg);" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 1V23" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M23 12H1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <button v-if="special_lightbox == 'user_settings_lightbox'" class="lightbox-close-btn" @click="closeUserSettingsLightbox()">
                <svg style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(45deg);" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 1V23" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M23 12H1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <button v-if="special_lightbox == 'select_creator_profile_lightbox'" class="lightbox-close-btn" @click="closeSelectCreatorProfilesLightbox()">
                <svg style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(45deg);" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 1V23" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M23 12H1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <slot></slot>
        </div>
      </div>
    </div>
</template>

<script>
import { EventBus } from "../event-bus";

export default {
  name: 'Lightbox',
  data() {
    return {
        toggleLightbox: false,
    }
  },
  methods: {
    closeUpdateCreatorProfile(){
      this.toggleLightbox = false;
      EventBus.$emit('close_creator_profile_update_modal_lightbox');
    },
    closeUserSettingsLightbox(){
      this.toggleLightbox = false;
      EventBus.$emit('close_user_settings_update_modal_lightbox');
    },
    closeSelectCreatorProfilesLightbox(){
      this.toggleLightbox = false;
      EventBus.$emit('close_select_creator_profile_add_lightbox');
    }
  },
  props: {
    'activateCommand': String,
    'deactivateCommand': String,
    'customClass': String,
    'special_lightbox': String,
  },
  created(){
    EventBus.$on(this.activateCommand, () =>{
        this.toggleLightbox = true;
    });
    EventBus.$on(this.deactivateCommand, () =>{
        this.toggleLightbox = false;
    });
  }



}
</script>

<style scoped>

</style>